import config from "@config";
import apiService from "@utils/ApiService";
import { deleteAuthorizationToken } from "@utils/utilities";
import { updateStateSubject } from "@gartner/genie-messenger-util";

export const redirectToLogin = () => {
  const origin = window.location.origin;
  let redirectToLogin = `${config.TOOL_URL}${config.API_PATH.LOGIN}`;
  if (origin.indexOf("developer.gartner.com") !== -1) {
    redirectToLogin = `${config.GENIE_AUTH_URL}`;
  }
  redirectToLogin += `?TARGET=${encodeURIComponent(origin)}${config.BASE_URL}`;
  deleteAuthorizationToken(config.GENIE_ACCESS_CODE);
  localStorage.setItem(config.LOGOUT_EVENT_KEY, "true");
  window.location.replace(redirectToLogin);
};

function logout() {
  apiService(config.GARTNER_URL)
    .post(
      config.API_PATH.LOGOUT,
      {},
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          withCredentials: true,
        },
      }
    )
    .catch(() => {
      window.location.reload();
    })
    .finally(() => {
      updateStateSubject("logout", {});
      redirectToLogin();
    });
}

export const autoLogout = () => {
  localStorage.setItem(config.LOGOUT_EVENT_KEY, false);

  window.addEventListener("storage", (event) => {
    if (event.key === config.LOGOUT_EVENT_KEY && event.newValue === "true") {
      logout();
    }
  });
};

export default logout;
